import { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import classNames from 'classnames/bind';
import autoBind from 'react-autobind';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck } from '@fortawesome/pro-regular-svg-icons/faCheck';

import * as trendingActions from '../../../actions/trendingBarActions';
import { trendingBarClassesArgumentCheck, checkAssets } from '../../../utils/trendingBarHelper';
import withComponentName from '../../../decorators/withComponentName';

import Styles from './styles.module.scss';

const cx = classNames.bind(Styles);

class TrendingBarDropDown extends Component {
  constructor(props) {
    super(props);
    autoBind(this);
    this.selectAllRef = null;
    this.dropDown = null;
  }

  componentDidMount() {
    document.addEventListener('click', this.handleClickOutside);
  }

  componentDidUpdate(prevProps) {
    const {
      selectedTrendingClasses,
      period,
      assetClasses,
      actions,
      piwikEnabled,
      allTrendingAssetClasses,
    } = this.props;

    if (
      selectedTrendingClasses.length !== prevProps.selectedTrendingClasses.length
    ) {
      const assetIds = selectedTrendingClasses.map((asset) => asset.id);
      actions.updateTrendingBarTopics(period, assetIds.join(','));
    }
    if (selectedTrendingClasses.length === assetClasses.length) {
      this.selectAllRef.checked = true;
    }

    if (piwikEnabled) {
      if (prevProps.period !== period) _paq.push(['trackEvent', 'Trending bar', 'Trending period', period]);

      if (
        prevProps.allTrendingAssetClasses !== allTrendingAssetClasses
        && allTrendingAssetClasses
      ) {
        _paq.push(['trackEvent', 'Trending bar', 'Select All Topic Classes ON']);
      } else if (
        prevProps.allTrendingAssetClasses !== allTrendingAssetClasses
        && !allTrendingAssetClasses
      ) {
        _paq.push(['trackEvent', 'Trending bar', 'Select All Topic Classes OFF']);
      }
    }
  }

  componentWillUnmount() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  handleClickOutside(e) {
    const { trendingBarFiltersOpened, actions } = this.props;
    if (
      this.dropDown && !this.dropDown.contains(e.target)
      && trendingBarFiltersOpened
      && e.target
    ) {
      actions.toggleTrendingFilters();
    }
  }

  selectTrendingClass(selectedTrendingClass) {
    const { piwikEnabled, actions, selectedTrendingClasses } = this.props;

    const assetClasses = (
      selectedTrendingClasses
        .filter(({ name }) => name !== selectedTrendingClass.name)
        .map(({ name }) => name)
    );

    actions.selectTrendingClasses(selectedTrendingClass);

    if (piwikEnabled) _paq.push(['trackEvent', 'Trending bar', 'Select asset class', assetClasses.join(',')]);
  }

  render() {
    const {
      actions,
      period,
      assetClasses,
      allTrendingAssetClasses,
      selectedTrendingClasses,
    } = this.props;
    const trendingPeriodClass = cx({
      trending_bar_period: true,
    });
    const trendingClasses = trendingBarClassesArgumentCheck(selectedTrendingClasses);

    return (
      <div className={Styles.trending_dropdown_wrapper} ref={(ref) => { this.dropDown = ref; }}>
        <div className={trendingPeriodClass}>
          <h1>Trending period</h1>
          <ul className="d-flex">
            <li>
              <a
                href="#"
                className={period === 'minutes15' ? `${Styles.active}` : null}
                onClick={() => actions.updateTrendingBarTopics('minutes15', trendingClasses)}
              >
                15 min
              </a>
            </li>
            <li>
              <a
                href="#"
                className={period === 'hour1' ? `${Styles.active}` : null}
                onClick={() => actions.updateTrendingBarTopics('hour1', trendingClasses)}
              >
                1 hour
              </a>
            </li>
            <li>
              <a
                href="#"
                className={period === 'day1' ? `${Styles.active}` : null}
                onClick={() => actions.updateTrendingBarTopics('day1', trendingClasses)}
              >
                1 day
              </a>
            </li>
          </ul>
        </div>
        <div className={Styles.topic_class}>
          <h1>Topic Class</h1>
          <div className={Styles.check_all_classes_wrapper}>
            <p>Select All Topic Classes</p>
            <div className={Styles.check_all_classes_checkbox}>
              <input
                type="checkbox"
                id="switch"
                checked={allTrendingAssetClasses}
                ref={(ref) => { this.selectAllRef = ref; }}
                onChange={() => actions.toggleSelectAll(allTrendingAssetClasses)}
              />
              <label htmlFor="switch" />
            </div>
          </div>
          <ul>
            {assetClasses.map((assetClass) => (
              <AssetClassCheckboxItems
                key={assetClass.id}
                {...assetClass}
                selectAsset={this.selectTrendingClass}
                selectedAllAssets={allTrendingAssetClasses}
                selectedTrendingClasses={selectedTrendingClasses}
                fullAssetClass={assetClass}
              />
            ))}
          </ul>
        </div>
      </div>
    );
  }
}

const AssetClassCheckboxItems = ({
  id,
  title,
  selectedTrendingClasses,
  fullAssetClass,
  selectAsset,
  selectedAllAssets,
}) => {
  const checked = () => (selectedAllAssets ? true : checkAssets(selectedTrendingClasses, id));
  return (
    <li>
      <div className={Styles.asset_checkbox}>
        <input
          type="checkbox"
          className={Styles.topic_class_checkbox}
          id={id}
          checked={checked()}
          onChange={() => selectAsset(fullAssetClass)}
        />
        <label htmlFor={id}>
          {title}
          <FontAwesomeIcon icon={faCheck} />
        </label>
      </div>
    </li>
  );
};

const mapDispatchToProps = (dispatch) => ({
  actions: bindActionCreators({ ...trendingActions }, dispatch),
});

const mapStateToProps = ({ trendingBarReducer }) => ({
  period: trendingBarReducer.period,
  assetClasses: trendingBarReducer.assetClasses,
  allTrendingAssetClasses: trendingBarReducer.defaultTrendingClass,
  selectedTrendingClasses: trendingBarReducer.selectedTrendingClasses,
  trendingBarFiltersOpened: trendingBarReducer.trendingBarFiltersOpened,
});

export default withComponentName(
  connect(mapStateToProps, mapDispatchToProps)(TrendingBarDropDown),
);
